<template>
  <div class="container sm" :class="[s.wrapper, s[helper.displayDirection]]">
    <div :class="s.logo_wrap">
      <div :class="s.logo">
        <img src="/img/logos/mitt_logo_512.png" alt="">
      </div>
      <h2 class="text-center fs-4 fw-bold">ログイン</h2>
      <!-- <div v-if="!isCurrent && appVersion && helper.nativeVersion" class="mt-3 p-3 bg-white rounded-2 bdr">
        <p class="fw-bold fc-red">アプリケーションのバージョンが最新ではありません。</p>
        <p>以下よりアプリケーションの更新をしてください。</p>
        <div
          class="mt-2 text-center"
          :class="s.submitButton"
          @click="toUpdateApp()">アプリケーションの更新をする</div>
      </div> -->
    </div>

    <div v-if="helper.device.isChecked" :class="s.content_wrap">
      <!-- 端末チェックの通信に失敗した場合（端末未登録との取り違えを防ぐ） -->
      <div v-if="helper.device.checkFailed">
        <div>
          <span :class="s.nowrap">サーバーに接続できません。</span><br>
          <span :class="s.nowrap">通信状態をご確認の上、</span>
          <span :class="s.nowrap">しばらくお待ちください。</span>
        </div>
      </div>

      <!-- device未認証時 -->
      <div v-else-if="!helper.device.officeId && helper.device.uuid">
        <div>端末が登録されていません。<br>
          <span :class="s.nowrap">事業所コードを入力し、</span>
          <span :class="s.nowrap">端末の登録を</span>
          <span :class="s.nowrap">完了させてください。</span>
        </div>
        <div class="fs-sm mt-3">事業所コード</div>
        <input
          type="text"
          class="form-control mb-2"
          v-model="officeSerialId">
        <div class="fs-sm">端末識別名</div>
        <input
          type="text"
          class="form-control mb-4"
          v-model="deviceName">
        <button
          type="button"
          :class="s.submitButton"
          @click="registAppUuid()">送信</button>
      </div>

      <div v-if="!helper.device.officeId && !helper.device.uuid">
        <div v-if="helper.isNative.app">
          <div class="mb-4 text-center">アプリケーションの更新が必要です。更新してください。</div>
          <div
            class="mt-2 text-center"
            :class="s.submitButton"
            @click="toUpdateApp()">アプリケーションの更新をする</div>
        </div>

        <!-- ネイティブ以外で開いている場合 -->
        <div v-else>
          <div :class="[s.content]" v-if="byIdPassword">
            <div>
              <label class="fs-sm" for="serialId">ログインID</label>
              <input
                id="serialId" name="serialId"
                class="form-control"
                type="text" placeholder="ログインID"
                v-model.trim="$v.serialId.$model"
                v-bind:class="{ input_error: validationFlags.serialId }"
                v-on:input="invalidsCheck('serialId', $v.serialId.$invalid)"
                @keydown.enter="keydownEnter($event)">
            </div>
            <div>
              <label class="fs-sm" for="password">パスワード</label>
              <input
                id="password" name="password"
                class="form-control"
                type="password" placeholder="パスワード"
                v-model.trim="$v.password.$model"
                v-bind:class="{ input_error: validationFlags.password }"
                v-on:input="invalidsCheck('password', $v.password.$invalid)"
                @keydown.enter="keydownEnter($event)">
            </div>
            <button
              type="button" class="mt-3"
              :class="s.submitButton"
              :disabled="!submitFlag"
              @click="submitBySerialId()"
              width="full">ログイン</button>
            <div class="mt-4 mb-2 text-center">
              <div>
                <span :class="s.nowrap">係員ID・パスワードを</span>
                <span :class="s.nowrap">お忘れの場合は</span>
                <span :class="s.nowrap">オペレーターまたは管理者に</span>
                <span :class="s.nowrap">お問合せください。</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- device認証済 -->
      <div v-if="helper.device.officeId && !byIdPassword">
        <ul :class="s.tab">
          <li
            v-for="type in formTypes"
            :key="type.name"
            @click="selectedTab = type.name"
            :class="[type.name === selectedTab ? s.selected : '']">{{ type.label }}</li>
        </ul>

        <!-- 名前選択でのログイン -->
        <div :class="[s.content, s.hasTab]">
          <TaxiDriverForm
            :officeId="helper.device.officeId"
            @changeIsReady="changeIsReady"
            @submitLogin="submitLogin"
            :styleClasses="s"
            :type="selectedTab"
            :ref="selectedTab" />
        </div>
      </div>

      <div v-if="helper.device.officeId && byIdPassword">
        <!-- ID/PASS でのログイン -->
        <div :class="[s.content]" v-if="byIdPassword">
          <div>
            <label class="fs-sm" for="serialId">ログインID</label>
            <input
              id="serialId" name="serialId"
              class="form-control"
              type="text" placeholder="ログインID"
              v-model.trim="$v.serialId.$model"
              v-bind:class="{ input_error: validationFlags.serialId }"
              v-on:input="invalidsCheck('serialId', $v.serialId.$invalid)"
              @keydown.enter="keydownEnter($event)">
          </div>
          <div>
            <label class="fs-sm" for="password">パスワード</label>
            <input
              id="password" name="password"
              class="form-control"
              type="password" placeholder="パスワード"
              v-model.trim="$v.password.$model"
              v-bind:class="{ input_error: validationFlags.password }"
              v-on:input="invalidsCheck('password', $v.password.$invalid)"
              @keydown.enter="keydownEnter($event)">
          </div>
          <button
            type="button" class="mt-3"
            :class="s.submitButton"
            :disabled="!submitFlag"
            @click="submitBySerialId()"
            width="full">ログイン</button>
          <div class="mt-4 mb-2 text-center">
            <div>係員ID・パスワードをお忘れの場合はオペレーターまたは管理者にお問合せください。</div>
          </div>
        </div>
      </div>
      <div class="mt-2 text-center fs-sm fc-gray">{{ helper.device.deviceName }}</div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import TaxiDriverForm from '@/components/parts/Login/TaxiDriverForm.vue';


export default {
  name: 'Login',
  mixins: [cf],
  components: {
    TaxiDriverForm,
  },
  data() {
    return {
      validationFlags: {
        serialId: false,
        password: false,
      },
      invalids: {
        serialId: true,
        password: true,
      },
      isReady: false,
      deviceName: '',
      officeSerialId: '',
      selectedTab: 'taxi',
      formTypes: [
        {
          label: 'タクシー',
          name: 'taxi',
        },
        {
          label: 'ライドシェア',
          name: 'rideshare',
        },
      ],
      appVersion: null,
    };
  },
  created() {
    const ua = navigator.userAgent;
    const [, versionUuid] = ua.split('MITT_APP_ANDROID_');
    const [version] = versionUuid ? versionUuid.split('_') : [null];
    this.appVersion = version;
  },
  setup() {
    const serialId = ref('');
    const password = ref('');

    const rules = {
      // メールは必須・email形式
      serialId: { required },
      // パスワードは必須
      password: { required, minLength: minLength(8) },
    };

    const $v = useVuelidate(rules, { serialId, password });

    return { serialId, password, $v };
  },
  computed: {
    ...mapState(['user', 'page', 'helper']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.serialId && !this.invalids.password;
    },
    isCurrent() {
      return this.helper.nativeVersion === this.appVersion;
    },
    byIdPassword() {
      const officeName = this.helper.device.officeName;
      const idPassLoginOfficeNames = ['higashiOsaka', 'higashiKagura', 'abira'];
      return idPassLoginOfficeNames.includes(officeName) || !this.helper.isNative.app;
    },
  },
  watch: {
    'helper.device.officeId': {
      handler() {
        this.hideLoading();
      },
    },
    'user.login.isLogin': {
      handler() {
        this.loginStatusCheck();
      },
    },
    'user.login.isChecked.isLogin': {
      handler() {
        this.loginStatusCheck();
      },
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    loginStatusCheck() {
      const loginData = this.user.login;
      if (loginData.isChecked.isLogin && loginData.isLogin) this.$router.push('/');
    },

    changeIsReady({ name, value }) {
      if (name === this.selectedTab) this.isReady = value;
    },
    updateSerialIdPrefix() {
      if (this.selectedOffice) {
        const prefix = this.selectedOffice.name;
        this.serialId = `${prefix}_${this.serialId.split('_').pop() || ''}`;
      }
    },

    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    keydownEnter(e) {
      if (e.keyCode === 13 && this.submitFlag) this.submitBySerialId();
    },

    submitBySerialId() {
      if (!this.submitFlag) return;
      const data = {
        loginType: 'default',
        password: this.password,
      };
      this.submitLogin(data);
    },

    // login処理実行
    // loginType = default は serialId でのログインのみ許容
    submitLogin(data) {
      const submitData = {
        loginType: data.loginType || 'default',
        password: data.password,
      };

      if (this.helper.isNative.app) {
        if (submitData.loginType === 'default' && !this.helper.device.officeName) {
          alert('ログインに必要な情報の取得に失敗しました。\nオペレーターまたは管理者にお問い合わせください。');
          return;
        }
  
        if (submitData.loginType === 'default') submitData.serialId = `${this.helper.device.officeName}_${this.serialId}`;
        if (submitData.loginType === 'onlyId') submitData.userId = data.userId;
      } else {
        submitData.serialId = this.serialId;
      }


      this.$store.dispatch('user/login/submit', submitData);
    },

    // [TODO] 東大阪開始前までに削除
    numatayaDeviceRegist() {
      this.showLoading();
      const timestamp = this.formatTimestamp(new Date(), 'YYYYMMDDHHmmss');
      this.axios({
        method: 'POST',
        url: '/v1/device/create',
        data: {
          officeSerialId: 'numataya',
          name: `numataya-${timestamp}`,
          uuid: this.helper.device.uuid,
        },
      })
        .then(() => {
          this.$store.dispatch('helper/checkDevice', this.helper.device.uuid);
        })
        .catch((error) => {
          const res = error.response?.data;
          if (error.response) console.log(error.response.data);
          else console.log(error);

          if (res?.status === 404 && res.message === '[Device create]: Office not found') {
            alert('入力された事業所コードは存在しません。入力内容を確認し再度お試しください。');
            this.hideLoading();
          }
        });
    },

    registAppUuid() {
      this.showLoading();
      this.axios({
        method: 'POST',
        url: '/v1/device/create',
        data: {
          officeSerialId: this.officeSerialId,
          name: this.deviceName,
          uuid: this.helper.device.uuid,
        },
      })
        .then(() => {
          this.$store.dispatch('helper/checkDevice', this.helper.device.uuid);
        })
        .catch((error) => {
          const res = error.response?.data;
          if (error.response) console.log(error.response.data);
          else console.log(error);

          if (res?.status === 404 && res.message === '[Device create]: Office not found') {
            alert('入力された事業所コードは存在しません。入力内容を確認し再度お試しください。');
            this.hideLoading();
          }
        });
    },

    toUpdateApp() {
      window.open('https://play.google.com/apps/internaltest/4701206284147486470', '_blank');
    },
  },
};
</script>

<style lang="scss" module>
// ログイン失敗時
.vibration {
  animation: vibration .1s  infinite;
}
@keyframes vibration {
  0% {transform: translate(0px, 0px) rotateZ(0deg)}
  25% {transform: translate(2px, 2px) rotateZ(1deg)}
  50% {transform: translate(0px, 2px) rotateZ(0deg)}
  75% {transform: translate(2px, 0px) rotateZ(-1deg)}
  100% {transform: translate(0px, 0px) rotateZ(0deg)}
}
</style>

<style lang="scss" module="s">
.wrapper {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 12px 32px;
  border-radius: 12px;
  border: 1px solid var(--border-gray);
  margin-top: 32px;
  .nowrap {
    white-space: nowrap;
  }
}
.content_wrap {
  height: 100%;
  margin-top: 32px;
  overflow: scroll;
}
.logo_wrap {
  .logo {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    > img {
      width: 100%;
      height: 100%;
    }
  }
}
.tab {
  display: flex;
  align-items: stretch;

  > li {
    padding: 12px 24px;
    width: 50%;
    text-align: center;
    margin-bottom: -1px;
    margin-right: -1px;
    background-color: #ffffff;
    color: var(--label-secondary);
    border-bottom: 3px solid var(--border-gray);
    > span {
      white-space: nowrap;
    }
    &.selected {
      font-weight: bold;
      color: var(--thema-color);
      border-bottom-color: #ffffff;
      border-bottom: 3px solid var(--thema-color);
    }

    &:first-child {
      border-top-left-radius: 12px;
    }
    &:last-child {
      border-top-right-radius: 12px;
    }
  }
}
.content {
  margin-top: 16px;
  &.hasTab {
    border-radius: 0 0 12px 12px;
    border-top: none;
  }
}
.submitButton {
  display: block;
  margin: 0 auto;
  padding: 24px 100px;
  background-color: var(--thema-color);
  color: #ffffff;
  font-weight: bold;
  border: 1px solid var(--thema-color);
  outline: none;
  border-radius: 8px;
  transition: all .3s;
  &:disabled {
    opacity: .5;
  }
  &.border {
    background-color: #ffffff;
    color: var(--thema-color);
  }
  &.full {
    width: 100%;
  }
  &.short {
    padding: 8px 100px;
  }
}

.horizontal {
  flex-direction: row;
  height: calc(100% - (32px * 2));
  overflow: scroll;

  .logo_wrap {
    margin-right: 24px;
    .logo {
      width: 150px;
      height: 150px;
    }
  }
  .content_wrap {
    margin-top: 0;
    flex: 1;
  }
}
</style>
